import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const UserSuggestions = () => {
  const navigate = useNavigate();

  const suggestedUsers = [
    {
      id: 1,
      name: "Sarah Chen",
      avatar: "https://images.unsplash.com/photo-1494790108755-2616b612b786?w=150",
      bio: "Environmental advocate • $12K donated",
      mutualConnections: 5,
      causes: ["Environment", "Education"],
      isFollowing: false
    },
    {
      id: 2,
      name: "Michael Rodriguez",
      avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150",
      bio: "Healthcare supporter • $8.5K donated",
      mutualConnections: 3,
      causes: ["Healthcare", "Children"],
      isFollowing: false
    },
    {
      id: 3,
      name: "Emily Johnson",
      avatar: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150",
      bio: "Education champion • $15K donated",
      mutualConnections: 8,
      causes: ["Education", "Women\'s Rights"],
      isFollowing: false
    }
  ];

  const handleFollow = (userId) => {
    console.log('Following user:', userId);
  };

  const handleViewProfile = (userId) => {
    navigate('/user-dashboard');
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="font-semibold text-card-foreground">Suggested Connections</h3>
        <Button variant="ghost" size="sm">
          <Icon name="RefreshCw" size={16} />
        </Button>
      </div>
      <div className="space-y-4">
        {suggestedUsers?.map((user) => (
          <div key={user?.id} className="flex items-start space-x-3 p-3 rounded-lg hover:bg-muted/50 transition-micro">
            <div className="w-12 h-12 rounded-full overflow-hidden bg-muted flex-shrink-0">
              <Image
                src={user?.avatar}
                alt={user?.name}
                className="w-full h-full object-cover"
              />
            </div>
            
            <div className="flex-1 min-w-0">
              <div className="flex items-center justify-between mb-1">
                <button
                  onClick={() => handleViewProfile(user?.id)}
                  className="font-medium text-card-foreground hover:text-primary transition-micro truncate"
                >
                  {user?.name}
                </button>
                <Button
                  variant="outline"
                  size="xs"
                  onClick={() => handleFollow(user?.id)}
                >
                  Follow
                </Button>
              </div>
              
              <p className="text-sm text-muted-foreground mb-2 line-clamp-2">
                {user?.bio}
              </p>
              
              {user?.mutualConnections > 0 && (
                <p className="text-xs text-muted-foreground mb-2">
                  {user?.mutualConnections} mutual connections
                </p>
              )}
              
              <div className="flex items-center space-x-1">
                {user?.causes?.slice(0, 2)?.map((cause) => (
                  <span
                    key={cause}
                    className="inline-block px-2 py-1 bg-primary/10 text-primary text-xs rounded-full"
                  >
                    {cause}
                  </span>
                ))}
                {user?.causes?.length > 2 && (
                  <span className="text-xs text-muted-foreground">
                    +{user?.causes?.length - 2} more
                  </span>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="mt-4 pt-4 border-t border-border">
        <Button
          variant="ghost"
          size="sm"
          onClick={() => navigate('/cause-discovery')}
          className="w-full justify-center"
        >
          <Icon name="Users" size={16} className="mr-2" />
          Discover More Donors
        </Button>
      </div>
    </div>
  );
};

export default UserSuggestions;